module.exports = __webpack_public_path__ + "img/cancel_red.1fb2d230.svg";